import { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { ArrowLeft, PenSquare } from "lucide-react";
import { Button } from "@/components/ui/button";
import { FullScreenLoader } from "@/components/auth/AdminGate";
import PreviewFrame from "@/components/editor/PreviewFrame";
import { DeviceToggle, ScaledDevice } from "@/components/editor/Canvas";
import { useApi } from "@/lib/api";

export default function Preview() {
  const { id } = useParams();
  const [qs] = useSearchParams();
  const vid = qs.get("version");
  const api = useApi();
  const [data, setData] = useState(null);
  const [device, setDevice] = useState(window.innerWidth < 700 ? "mobile" : "desktop");
  useEffect(() => {
    Promise.all([api.get(`/projects/${id}`), api.get(`/projects/${id}/assets`), vid ? api.get(`/projects/${id}/versions/${vid}`) : null]).then(([p, a, v]) => {
      setData({ project: v ? { ...p.data, content: v.data.content } : p.data, assets: a.data, version: v?.data });
      document.title = `Anteprima · ${p.data.name}`;
    });
  }, [api, id, vid]);
  if (!data) return <FullScreenLoader />;
  const { project, assets, version } = data;
  return (
    <div className="h-screen flex flex-col bg-navy-950" data-testid="preview-page">
      <div className="h-12 shrink-0 flex items-center justify-between px-3 sm:px-4 border-b border-navy-800">
        <div className="flex items-center gap-3 min-w-0">
          <Link to="/" className="text-slate-400 hover:text-white" aria-label="Dashboard" data-testid="preview-back-link"><ArrowLeft size={18} /></Link>
          <p className="text-sm text-white truncate">{project.name}</p>
          {version
            ? <span className="text-[10px] uppercase tracking-wider text-amber-300 truncate" data-testid="preview-version-label">Versione: {version.label}</span>
            : <span className="hidden sm:inline text-[10px] uppercase tracking-wider text-slate-500">Anteprima (ultima versione salvata)</span>}
        </div>
        <div className="flex items-center gap-2">
          <DeviceToggle dark device={device} onChange={setDevice} />
          <Button asChild size="sm" variant="secondary" className="hidden sm:inline-flex"><Link to={`/projects/${id}`} data-testid="preview-edit-link"><PenSquare size={14} className="mr-1.5" />Editor</Link></Button>
        </div>
      </div>
      <div className="flex-1 min-h-0 flex flex-col p-0 sm:p-3">
        <ScaledDevice device={device}>
          <PreviewFrame content={{ ...project.content, brand_name: project.company_name }} assets={assets} path="/" />
        </ScaledDevice>
      </div>
    </div>
  );
}
